<section class="avatar-editor" [ngClass]="{'with-overlay': status==STATUS_ERROR_UPLOAD}">
    <core-layout-modal-feedback class="modal-feedback" 
      *ngIf="status==STATUS_ERROR_UPLOAD" [type]="'fail'" [message]="'Error'"
      [text]="'Please upload a valid image file.'" [buttonText]="'retry'"
      (action)="dismissError()">
    </core-layout-modal-feedback>
  <article *ngIf="view==VIEW_MAIN">
    <span class="modal-close" (click)="cancel()" title="Close">✕</span>
    <header>
      <core-title-section
      [title]="'Profile photo'"
      [description]="''"
      ></core-title-section>
    </header>
    <div class="avatar-editor-cropper">
      <figure>
        <core-avatar-img [user]="user" [size]="250" [onlineIcon]="false"> </core-avatar-img>
      </figure>
    </div>
    <fieldset>
      <div>
        <core-helpers-forms-button-white [text]="'Edit'" [disabled]="file==null" (click)= "show(VIEW_EDIT)"></core-helpers-forms-button-white>
        <core-helpers-forms-button-white [text]="'Add photo'" (click)="show(VIEW_UPLOAD)"></core-helpers-forms-button-white>
      </div>
      <core-helpers-forms-button-white [text]="'Delete'" [disabled]="file==null" (click)="delete()"></core-helpers-forms-button-white>
    </fieldset>
  </article>

    <profile-avatar-upload *ngIf="view==VIEW_UPLOAD" (uploaded)="uploadFile($event)" (cancel)="cancelOption()"></profile-avatar-upload>
    <profile-avatar-edit *ngIf="view==VIEW_EDIT" (cancel)="cancelOption()" (save)="saveOption($event)" [file]="file" [options]="options"></profile-avatar-edit>
</section>
